module.exports = __webpack_public_path__ + "img/curious_addys_tab_highlight.53735b33.png";